import React, {Component} from 'react';
import '../App.css';
import axios from 'axios';
import cookie from 'react-cookies';

import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';

//Define a Login Component
class Login extends Component{
    //call the constructor method
    constructor(props){
        super(props);

        this.state = {
            useremail: localStorage.getItem('userEmail'),
            password: localStorage.getItem('password'),
            message: "",
            authFlag: false,
            checked: false
        }

        cookie.remove('cookieId', { path: '/' });
        
        this.useremailChangeHandler = this.useremailChangeHandler.bind(this);
        this.passwordChangeHandler = this.passwordChangeHandler.bind(this);
        this.submitLogin = this.submitLogin.bind(this);        
    }
    //Call the Will Mount to set the auth Flag to false
    componentWillMount(){
        this.setState({
            authFlag : false
        })        
    }

    //useremail change handler to update state variable with the text entered by the user
    useremailChangeHandler = (e) => {
        this.setState({
            useremail : e.target.value
        })
    }
    //password change handler to update state variable with the text entered by the user
    passwordChangeHandler = (e) => {
        this.setState({
            password : e.target.value
        })
    }
    
    handleValidation(){
        let formIsValid = true;

        //Password
        if(!this.state.password){
            formIsValid = false;
            this.setState({
                message : "Password is a Required field."
            })
        }

        //useremail
        if(!this.state.useremail){
            formIsValid = false;
            this.setState({
                message : "Email is a Required field."
            });
        }
        
        return formIsValid;
   }
    //submit Login handler to send a request to the node backend
    submitLogin = (e) => {
        e.preventDefault();

        if(this.handleValidation()){
            const data = {
                useremail : this.state.useremail,
                password : this.state.password
            }
            //set the with credentials to true
            axios.defaults.withCredentials = true;
            //make a post request with the user data
            axios.post(window.$backend_url + '/login',data)
                .then(response => {
                    if(response.status === 200){
                        if (this.state.checked) {
                            localStorage.setItem('userEmail', this.state.useremail);
                            localStorage.setItem('password', this.state.password);
                        }

                        this.props.setUserName();
                        this.props.closeLoginPopup();
                    }
                })
                .catch(error => {
                    if ( error.response.status === 800 ) {
                        this.setState({
                            message : "Your account is pending now."
                        })
                    } else {
                        this.setState({
                            message : "Authentication Unsuccessful."
                        })
                    }
                })
        }
    }

    switchPopupSignup = (e) => {
        e.preventDefault();
        this.props.switchPopupSignup();
    }

    switchPopupForgotPwd = (e) => {
        e.preventDefault();
        this.props.switchPopupForgotPwd();
    }

    responseFacebook = (response) => {
        if ( response.email ) {
            const data = {
                    useremail: response.email,
                    first_name: response.first_name,
                    last_name: response.last_name,
                    profile_img: response.picture.data.url
                }
            
            axios.defaults.withCredentials = true;
            
            axios.post(window.$backend_url + '/createFromSocial',data)
                .then(response => {
                    if ( response.status === 200 ){
                        this.props.setUserName();

                        this.props.closeLoginPopup();
                    }
                })
        }
    }

    responseGoogle = (response) => {
        if (response.profileObj) {
            if ( response.profileObj.email ) {
                const data = {
                        useremail: response.profileObj.email,
                        first_name: response.profileObj.givenName,
                        last_name: response.profileObj.familyName,
                        profile_img: response.profileObj.imageUrl
                    }
                //set the with credentials to true
                axios.defaults.withCredentials = true;
                //make a post request with the user data
                axios.post(window.$backend_url + '/createFromSocial',data)
                    .then(response => {
                        if ( response.status === 200 ){
                            this.props.closeLoginPopup();
                            this.props.setUserName();
                        }
                    })
            }
        }
    }

    handleCheckboxChange = e => {
        this.setState({ 
            checked: e.target.checked
        })
    }

    render(){

        const Checkbox = props => (
          <input className="check-remember" id="check-remember" type="checkbox" {...props} />
        )

        return(            
            <div className="modal-login custom-modal">
                <div className="modal-logo">
                    <img alt="logo" src="/assets/images/logo.png" />
                </div>
                <h2 className="text-center">{this.props.dataLanguage['signin']}</h2>
                <form className="login-form">
                    { this.state.message ?
                        <p className="message-text">{ this.state.message }</p>
                    : null }
                    <div className="form-group">
                        <label>{this.props.dataLanguage['email']}</label>
                        <div className="user-container">
                            <input onChange = {this.useremailChangeHandler} type="email" className="form-control useremail" name="useremail" value={this.state.useremail} />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>{this.props.dataLanguage['password']}</label>
                        <div className="pwd-container ">
                            <input onChange = {this.passwordChangeHandler} type="password" className="form-control password" name="password" value={this.state.password} />
                        </div>
                    </div>
                    <button onClick = {this.submitLogin} type="submit" className="btn-submit">{this.props.dataLanguage['signin']}</button> 
                    <div className="row">
                        <div className="col-6">
                            <div className="form-group">
                                <Checkbox checked={this.state.checked} onChange={this.handleCheckboxChange} />
                                <label className="label-remember" htmlFor="check-remember">{this.props.dataLanguage['rememberMe']}</label>
                            </div>
                        </div>
                        <div className="col-6 text-right">
                            <a href="" className="link-forgot-pwd"  onClick={this.switchPopupForgotPwd}>{this.props.dataLanguage['forgotYourPwd']}</a>
                        </div>
                    </div>
                </form>
                <div className="text-center">
                    <div className="social-buttons">
                        <div className="button-container">
                            <FacebookLogin appId="1575954682554038" textButton={this.props.dataLanguage['signinFacebook']} fields="first_name,last_name,email,picture" callback={this.responseFacebook} icon="fa-facebook-square" />
                        </div>
                        <div className="button-container google-login-container">
                            <GoogleLogin clientId="767698655664-p8gt09jfphcagt3orhdqvss1v8s64jt1" buttonText={this.props.dataLanguage['signinGoogle']} onSuccess={this.responseGoogle} onFailure={this.responseGoogle} />
                        </div>
                    </div>
                    <span className="other-link">{this.props.dataLanguage['dontAccount']} <a href="" className="link-yellow" onClick={this.switchPopupSignup}>{this.props.dataLanguage['signup']}</a></span>
                </div>
            </div>
        )
    }
}
//export Login Component
export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js